goog.provide("shadow.js.shim.module$$mui$x_charts$hooks");
goog.provide("module$shadow_js_shim_module$$mui$x_charts$hooks");
shadow.js.shim.module$$mui$x_charts$hooks = shadow.js.nativeProvides["@mui/x-charts/hooks"] = shadow$bridge("@mui/x-charts/hooks");
module$shadow_js_shim_module$$mui$x_charts$hooks.default = shadow.js.shim.module$$mui$x_charts$hooks;
